<template>
  <Modal class="max-w-[600px]!">
    <Modal.Title>Ownership</Modal.Title>
    <Modal.Body>
      <FileOwnersBody :file="file" />
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'
import type { File } from '@/shared/graphql/router/graphql'
import FileOwnersBody from './FileOwnersBody.vue'

defineProps<{
  file: File
}>()
</script>
